export const locale = {
  lang: "tn",
  data: {
    Global: {
      rTicket: "بحث التذاكر",
      ncs: "أحرف خاصة لا",
      vSuj: "الرجاء اختيار الموضوع",
      rec: "مطالبة",
      di: "طلب معلومات",
      rem: "شكرًا",
      av: "رأي",
      success: "نجاح",
      info: "معلومة",
      err: "خطأ",
      tousS: "الخدمات الكل",
      tnd: "دت",
      bonus: "مكافأة",
      dt: " دت",
      boutonpd: "أكثر تفاصيل ",
      opp: "بورتابيليتي",
      oo: "أوريدو",
      tt: "إتصالات تونس",
      or: "أورنج",
      valider: "تأكيد",
      org: "مؤسسة",
      ref: " رمز",
      montant: "المبلغ",
      mp: "المبلغ المدفوع",
      env: "أبعث",
      max: "أكثر حاجة",
      conf: "أكد",
      renv: "عاود ابعث",
      ann: "إلغاء",
      retourcnx: "ارجع لصفحة الاتصال",
      retour: "رجوع",
      continuer: "كمل ",
      passer: "تعدى المرحلة هاذي",
      suiv: "لي بعدو",
      payer: "خلص",
      rp: "إيصال الدفع",
      rt: "إيصال العملية",
      pnv: "خلص بكارت جديدة",
      mdp: "كيفاه نخلص ",
      date: "تاريخ",
      it: "معرف العملية",
      dateOp: "تاريخ العملية",
      etat: "الحالة",
      ea: "En attente",
      bonusg: "بونيس إلي ربحتو",
      pfc: "مجموع نقاط الوفاء إلي ربحتها ",
      sold: "رصيد",
      msg: " كفأنك على مشترياتك ، صب فلوس  تشكرك على وفائك",
      astuce: "فازات صب فلوس",
      rEmailActif: "",
      supportADisposition: "كان عندك إستفسار تنجم تتصل بخدمة العملاء متاعنا نحنا على ذمتك",
      desWallet1: ".الولات هاي ستوشك الإفتراضي إلي يخليك تتصرف في فلوسك",
      desWallet2: "تنجم تبعث وتقبل فلوس وتخلص بكل سهولة",
      pts: "نقاط",
      confirm: "تأكيد",
      confdemande: "أكد الطلب متاعك",
      resOp: "نتيجة العملية إلي قمت بها",
      vRes: "شوف النتيجة",
      choixMP: "إختار طريقة دفع",
      addBenf: "زيد متلقي",
      avis: "اعطينا رايك",
      wlc: "أنت توا متصل على صُب فلوس🎉 ، مرحبًا 👋",
      tapmsg: "إكتب الميساج متاعك ",
      pin: "ال-PIN تقيد بنجاح",
      msgcode: "لازم تكتب على الأقل code ولا تتعدى الخطوة هذي ",
      mconf: "👋 لقد قمت بتأكيد البريد الإلكتروني ",
      tconf: "👋 لقد قمت بتأكيد نومرو التلفون ",
      imgmsg: "نقبل نوعية الملفات (JPG، PNG و-JPEG) وكبروا لازم ما يفوتش 5MO",
      paymsg: "ما تنجمش تخلص بال-carte هذي ",
      wallmsg: "ما تنجمش تخلص بالمحفظة",
      editmsg: "تمت عملية التغير بنجاح ",
      gcb: "الcarte هذي تفسخت ",
      rib: "ال-RIB ما يمثلش حتى بنك، لازم تثبت ",
      editben: "تمت عملية تغيير المستفيد بنجاح ",
      tranmsg: "إكتب النومرو والمبلغ ",
      max50: "الحد الأقصى للمبلغ هو 50 دينارًا",
      numinv: "نومرو التلفون مش صحيح ",
      wallins: "المبلغ في المحفظة متاعك ما يكفيش ",
      fav: "تنجم تنزل على نجمة بش تشوف الخدمات المفضلة عندك",
      notif: "نوتيفيكاسياونات",
      notif2: "موش مقروءة",
      notif3: "عرض كل شي",
      notif4: "مفماش حتى نوتيفيكاسيون",
      param: "الإعداد",
      faq: "الأسئلة الشائعة",
      deco: "الخروج",
      cb: "كومبت بنكار",
      paym: "خلاص مع تاجر",
      wsf: "سطوش صب فلوس",
      aw: "شرجي سطوش بي",
      cp: "كارت الدفع",
      vv: "إيداع / تحويل",
      rev: "تاجر",
      pre: "لي قبلو",
      dastuce: "تحب تسجل الكارت هاذي بسهولة و- فيسع و بأمان للمرة الجاية؟",
      pm: "موش توا",
      enr: "تسجيل",
      frais: "رسوم",
      transuc: "العملية تعدات بنجاح",
      lcom: "خلي تعليق",
      com: "تعليق",
      noter: "تقييم",
      sms: "إرسالية",
      codeenv: "دخل كود لتبعث إلى",
      codeenva: "الكود تبعث إلى",
      codeenvnum: "الكود تبعث  للنومرو",
      codee: "دخل الكود لتبعث على",
      mvs: "عمليات الرصيد الائتماني",
      dd: "تاريخ البداية",
      df: "تاريخ النهاية",
      nomv: "مفما حتى عملية في الرصيد الائتماني الخاص بيك",
      merci: "شكراً على عملية الشراء إلي قومت بها",
      ta: "حول فلوسك",
      rbank: "نومرو  الكومبت بنكار",
      nvs: "رصيدك الجديد",
      infoB1: "تنجم تتمتع ببونيس صب فلوس بعد ماتشري أي خدمة على منصتنا.",
      infoB2: "يتزادلك مبلغ البونيس لصولد بونيس متاعك بالوقت بعد متأكد الدفع.",
      infoB3: "تنجم بعد تحول صولد بونيس لصولد القديم متاعك وتتمتع بالخدمات المتوفرة.",
      infoAvoir:
        "الصولد الائتمان يمثل الفلوس إلي تصبتلك من تعويض وإلى لأي سبب اخر وهو يخليك بعد تخلص الخدمات إلي توفرهم صب فلوس.",
    },
    Dash: {
      title1: "سوتشي ",
      stnd: "رصيد بدينار تونسي",
      da: "اخر شحن",
      dt: "اخر تحويل",
      alim: "شرجي",
      tran: "تحويل",
      tiktak: "تيك تاك",
      dTiktak: "أشري في رمشة عين بإستعمال خدمتنا جديدة تيك تاك",
      boutonTiktak: "اكتشف",
      titletran: "معاملات",
      dTran: "أخر عمليات قمت بها على صب فلوس",
      sfid: "مدى اخلاصك لنا ",
      dtbonus: "بونيس لي ربحتو",
      tsoldeavoir: "تحويل الى رصيد الموجود ",
      soldeav: "رصيدك الموجود هو ",
      titlequick: "تحويل فلوس الى حساب آخر صب فلوس ",
      titlequick2: " نزيد المستفيد  ",
      demwallet: "طلب محفظة ",
      as: "اشري على صب فلوس",
      std: "مقاس موحد ",
      pf: "النقاط إلي جمعتهم",
      messolde: "فلوسي ",
      suivisolde: "نتبع فلوسي",
      sa: "الوضعية الحالية",
      qt1: "حصة شراء الخدمات هي ",
      qt2: "دينار تونسي في اليوم",
      gservF: "تصرف في الخدمات إلي تحبها",
      notif: "إشعارات",
      sc: "مرشد الحرفاء",
      trB: "تحويل البونيس للصولد القديم",
    },
    tiktak: {
      tiktak: "تيك تاك",
      title: "خلاص يكون من خلال رصيد محفظتك صب فلوس ، إنزل",
      title1: "شحن الهاتف عن طريق تحويل مباشر",
      title2: "شحن الهاتف ببطاقة شحن",
      title3: "خلاص فاتورات",
      msg1: "باش تعمل  تحويل مباشر ب ",
      msg2: "دت لي رقم تليفون",
      payer: "خلص",
      recu: "توصيل",
      rautre: "شحن رقم تليفون آخر",
      msg3: "نجاح العملية",
      msg4: "انزل على توصيل بش تعرف رمز شحن",
      msg5: " شريت بطاقة شحن الهاتف ",
      msg6: "بقيمة",
      tdtitle: "تحويل سريع",
      msg7: "نجاح عملية شحن تليفون",
    },
    verf: {
      title: "تابع لعملية تثبيت ال-e-mail ونومرو تليفون باش تنجم تعمل للحساب متاعك",
      confM: "تأكيد عنوان بريد الالكتروني ",
      confM2: "عنوان بريدي  الالكتروني  صحيح",
      confT: "تثبيت نومرو التليفون ",
      confT2: "رقم تليفون مؤكد ",
      verCompte: "نفعل  الحساب ",
      d1: "إكتب الكود إلي وصلك على",
      contenu1: "نبدل بريد الالكتروني ",
      contenu2: "رقم تليفون جديد",
      desVer: "تثبيت الحساب وخلق محفظة جديدة",
      des: "ثبت هويتك وإستفاد من الوصول غير المحدود إلى جميع الخدمات على صب فلوس",
      cj: "دخول الفلوس فاليوم",
      mcj: "قداش تنجم تخرج كل يوم",
      ocj: "قداش تنجم دخل كل يوم",
      o: "عمليات",
      mocj: "قداش من مرة تنجم تخرج فلوس في اليوم",
      sw: "قداش عندي فلوس في سطوشي",
      v: "مفعل",
      enc: "مازلنا نراجعو فالطلب متاعك",
      rf: "عمر الاستماره عبر الانترنت",
      oui: "أي",
      non: "لا",
    },
    control: {
      champobli: "خانة لازمة",
      min6: "6 أرقام كحد أدنى",
      min6c: "على الأقل 6 حروف",
      max16: "أكثر حاجة 16",
      invFormat: "الشكل غالط",
      min2: "أقل حاجة 2",
      max2: "أكثر حاجة 2",
      montantinc: "المبلغ غالط ",
      mailob: "الإمايل لازم",
      mailv: "إكتب adresse mail صحيحة ",
      codeinc: "ال-code غالط ",
      numinv: " نومرو التلفون مش صحيح ",
      piniden: "الكود بين لازم يكون كيف كيف",
      patterPrenom: "لازم تكتب لقب صحيح ",
      patterNom: "رجاء ادخل اسما صحيحا",
      mdp: "يجب أن تتكون كلمة المرور الخاصة بك من 8 أحرف على الأقل (مجموعة من الأرقام والأحرف وحرف MAJ و MIN واحد على الأقل)",
      mdpinv: "كلمة السر مش صحيحة ",
      mdpidn: "كلمات المرور لازم يكونوا كيف كيف بالضبط ",
      mode: "إختار طريقة بعثان ال-code",
      nomval: "لازم تكتب إسم صحيح ",
      pin6: "ال-code PIN يتكون من 6 أرقام ",
      pininc: "ال-code PIN غالط ",
      max: "الحد الأقصى ",
      min1dt: "الحد الأدنى 1 دينار",
      min10dt: "الحد الأدنى 10 دينار",
      dd: "لازم تكتب تاريخ البدء ",
      df: "لازم تكتب تاريخ الانتهاء",
      opob: "لازم تختار نوع العملية ",
      rib: "ال-RIB يتكون من 20 رقم ",
      min4: "على الأقل 4 حروف",
      min: "أقل حاجة",
      maxi: "أكثر حاجة",
      inv: "غير صالح",
      dfsup: "تاريخ النهاية لازم يكون أكثر من تاريخ البداية",
      top: "نوع العملية",
      cinv: "كود الجمعية غالط",
      c100m: "ما تنجمش تفوت 100 حرف",
      mmin: "أقل مبلغ",
    },
    placeholder: {
      numtel: "نومرو تليفون",
      mont: "مبلغ",
      numver: "نومرو الوصل",
      trVV: "نزل إيصال متاع عملية التحويل البنكي",
      idw: " نومرو الحساب ولا e-mail متاع المتلقي",
      motiftran: "سبب تحويل ",
      motiftran2: "سبب بعثان الفلوس، خلي رسالة الى الطرف إلي بش يقبل فلوس",
      rib: "المعرف البنكي",
      bank: "البانكة",
      searchfav: "البحث مفضل",
      numfav: "نومرو تليفون",
      search: "بحث",
      cm: "كود التاجر",
      etq: "ملصق",
      nmail: "بريد إلكتروني جديد ",
      cP: "كود س.م.س",
      cM: "كود e-mail",
      mP: "بدل نومرو تليفون",
      mM: "بدل ال-e-mail",
      davis: "ما تترددش باش تبعثلنا توصية أو رأي أو ملاحظة. رايك يهمنا",
    },
    Connexion: {
      welcome: "مرحبا بيك في صب فلوس ",
      msg1: "أدخل على  حسابك",
      dPIN2: "أمانك  هو أولويتنا دخل رقم سري",
      msg3: "جديد على صب فلوس?",
      msg4: "تحل حساب",
      pin: "رقم سري",
      pinoub: "نسيت رقم سري ؟",
      cnx: "الدخول",
    },
    Inscri: {
      title: "المغامرة تبدأ من هوني",
      title2: "سجل في صبفلوس، ما تشدش وقت وبلاش فلوس",
      dPIN: "لسلامة معلوماتك  أكتب رقم سري",
      errmsg1: "عنوان بريد الالكتروني لي كتبتو مسجل على صب فلوس",
      errmsg2: " بريد الإلكتروني هذا  مسجل معنا",
      title4: "عندك معنا حساب ؟",
      title5: "أدخل لحسابك ",
      title6: "ولا سجل عن طريق",
      confpin: "بدل كود صب فلوس",
      condi: "شروط الإستعمال",
      condi2: "سياسة الخصوصية",
      et: "و",
      condi3: "تعويض الفلوس",
      condi4: "من صب فلوس",
      ng: "اسم المدير",
      pg: "إسم مدير",
      nummob: "نومرو تليفونك",
      numfix: "نومرو الفيكس",
      sd: "دومان الخدمة",
      fj: "الشكل القانوني",
      pp: "شخص عادي",
      sarl: "شركة بمسؤولية محدودة",
      sa: "شركة مجهولة المساهمين",
      suarl: "شركة فردية بمسؤولية محدودة",
      numi: "رقم بطاقة تعريف",
      numiinv: "رقم الهوية غالط",
    },
    forgotPass: {
      rPW: "بدل كلمة السر",
      descMP: "إكتب ال-e-mail و نومرو تليفون إلي مربوطين بال- compte متاعك",
      dPW: "أكتب كلمة سر جديدة",
    },
    ResetPin: {
      rPIN: "نعاود  رقم سري",
      dPIN3: "أكتب رقم سري جديد",
    },
    Browsec: {
      sauv: "سجل  المتصفح",
      title: "تحقق من الهوية",
      title1: "بش تدخل على حسابك بأمان، نحبو نتحققوا من هويتك",
    },
    vPIN: {
      title: "كود PIN",
      des: "",
    },
    Carte: {
      alimCarte: "شرجي بال-carte",
      dAlimCarte: "إختار المبلغ و ال-carte",
      Conf: "تأكيد",
      RS: "نتيجة عملية ",
      D1: "إشحن محفظتك صب فلوس  من خلال بطاقتك  على انترنت بكل  أمان",
      desAlim: "أكتب مبلغ ، أختار بطاقة لي حاشتك بها",
      aw: "شرجي محفظتك",
      rw: " شرجي محفظتك",
      numver: "رقم التحويل / الإيداع",
      numc: "نومرو الكومبت",
    },
    Espece: {
      title1: "شرجي الحساب متاعك عن طريق تحويل/دفع",
      title2: "قائمة المكاتب",
      AE: " شحن محفظة نقدا ",
      DAC: "عمر الطلب متاعك",
      Conf: "تأكيد",
      RS: "نتيجة عملية ",
      D1: "ماعندكش كيفاش تخلص بكارتا على الانترنت، صب فلوس مجعولة لك بش تعاونك ",
      D2: "تنجم تصب فلوس نقدا في واحد من حساباتنا البنكية عن طريق إيداع/تحويل بنكي",
    },
    popRes: {
      title: "ماكش مؤهل",
      des: "",
      title2: "التفعيل",
    },
    AccountSet: {
      title: "معلومات شخصية ",
      bouton: "نبدل",
      des: "JPG, GIF ou PNG مسموحين، أكبر حجم 800 Ko",
      pmcp: "إعدادات الحساب",
      vw: "التفعيل  و- السطوش",
      nom: "اللقب",
      prenom: "الاسم",
      dn: "تاريخ الولادة",
      ville: "مدينة",
      modifmdp: "تبديل كلمة السر",
      modifpin: "تبدل كود صب فلوس",
      modifmail: "بدل الايمايل",
      hismail: "تاريخ الايمايل",
      vpin: "ثبت في كود صب فلوس على كل عملية تصير",
      cc: "سكر حسابك",
      ancienpass: "كلمة السر القديمة",
      vpass: "كلمة السر الجديدة",
      cpass: "تأكيد  كلمة السر",
      ancienpin: "كود صب فلوس القديم",
      vmpin: "كود صب فلوس الجديد",
      cpin: "تأكيد كود صب فلوس",
      ancientel: "رقم التليفون القديم",
      vtel: "رقم التليفون الجديد",
      mdp: "كلمة السر",
      numide: "أرقام لازم يكونوا موش كيفكيف",
      scode: "كود التثبت",
      mdpoub: "نسيت كلمة السر?",
      ancienm: "الإيمايل القديم",
      hemail: "سجل تبديل الإيمايل",
      email: "الإيمايل",
      du: "تاريخ الاستعمال",
      dm: "تاريخ التغيير",
      vk: "دخل المعطيات اللازمة عن طريق الإستمارة هاذي بش تتحصل على سطوش صب فلوس",
    },
    Rev: {
      title:
        "إشحن محفظتك صب فلوس من عند بائعين صب فلوس ، أمشي  لي اقرب بوتيك ،اعطيه الفلوس  نقدا  بش تلقا الفلوس تصبت بالوقت .",
      rev: "بائعين",
      search: "لوج على بائع",
    },
    CashOut: {
      title1: "ابعث فلوس الى والات صب فلوس",
      wFav: "حسابات المتلقين المفضلة عندك",
      tw: "تحويل فلوس للمحفظة",
      dtw: "عمر الطلب متاعك",
      tvw: "Tتحويل الى محفظة ",
      d1: "بحسابي نجم نبعث فلوس بالوقت لحساب أخر على صب فلوس، وين ما كنت ووقت ما نحب",
      d2: "عمر طلب متاعك باش تبعث فلوس، بعد ما تأكد العملية الفلوس توصل بالوقت للطرف المقابل",
      dwf: "تحويل مالي سهل وسريع لحسابات المتلقين المفضلة عندك",
      title3: "تحويل فلوس الى حساب بنكي ",
      title4: "حساباتي بنكية",
      d3: "طلب بعثان فلوس",
      d4: "حول فلوس بأمان ومضمون للحساب البنكي ! هذا التزامنا",
      mcb: "ادارة حسابات بنكية",
      addrib: "لازمك تسجل معرف بنكي بش تنجم تحول لحساب بنكي ",
      conftran: "أكد عملية التحويل",
      addBenf1: "زيد حساب لمتلقي في liste متاع المتلقين المفضلين عندك",
      nombenf: "إسم المتلقي",
      confdem: "أكد طلب التحويل",
      addRIB: "زيد حساب بنكي",
      desAddR2: "إكتب رقم حسابك ونزل تصويرة المعرف البنكي متاعك",
      dmen: "طلب تحويل الفلوس",
      vb: "تحويل بنكي",
      dd: "تاريخ الطلب",
      nbenf: "إسم المستفيد",
      rbenf: "رقم حساب المستفيد",
      mwall: "تبديل المستفيد",
      nomben: "إسم المستفيد",
      vnomben: "لازم تدخل إسم مستفيد صحيح",
      img: "تصويرة",
      title2: "إختار صولد إلي تحب تعمل منو التحويل",
    },
    RechTel: {
      d1: "شرجي تليفونك بطريقة ساهلة وخوذ بونيس على صب فلوس",
      d2: "إكتب نومرو تليفونك والمبلغ إلي تحب تصبو وخلص وإنت مطمان، تليفونك يتشرجى في الوقت",
      gmf: "إدارة مفضلين",
      d4: "إختار كارت متع تليفون إلي حاشتك بها وخلص وإنت مطمان. والكود يوصلك بالوقت ",
      cr: "إيصال الدفع",
      msg: "تمت مكافأتك على عملية الشراء إلي عملتها . صب فلوس تشكرك على وفائك",
      rn: "شرجي مرة أخرى",
      codeRech: "كود رشارج",
      addFav: "زيد في liste المفضلة",
      gFav: "إدارة النوامر المفضلين عندك",
      daddFav: "زيد النوامر متاع العباد المقربين لك لل-liste متاع المفضلين عندك",
      td: "حول ديركت لتلفونك",
      vcr: "كود الشحن الخاص بك",
      v: "قيمة",
      adfav: "زيد نومرو مفضل عندك",
      imgfav: "تصويرة مفضلة",
      add: "زيد",
      edfav: "بدل نومرو التليفون المفضل عندك",
      num8: "نومرو التليفون  8 أرقام",
      numTel: "نومرو التليفون",
    },
    Marchand: {
      DES1: "ادفع مع التجار الشركاء بأمان عبر حساب صُب فلوس الخاص بك واستفد من المكافآت والعروض الترويجية. اكتشف قائمة أفضل التجار الذين يقبلون صُب فلوس كوسيلة للدفع ",
      DES2: "اكتشف قائمة احسن تجار  لي يقبلو صب فلوس  كوسيلة دفع",
      DES3: "عمليات خلاص امنة وتتكافأ عليها على المواقع إلي نتعاملو معها على صب فلوس",
      DES4: "عمل shopping متاعك وخلص بكل أمان",
      DES5: "تستحق نعاونوك ؟ ما تترددش وكلم خدمة الزبائن الخاصة بنا ",
      dcc: "على مواقع التجار شركائنا ، بمجرد أن تطلب سلعة أو خدمة عن طريق اختيار متابعة الدفع مع صُب فلوس. يتم إنشاء رمز الدفع عبر الإنترنت لتحديد طلبك ، وهذا هو رمز الطلب",
      T1: "خلص شركائنا",
      DT1: "إكتب الكود commande",
      T4: "نتيجة عملية ",
      DT4: "شوف نتيجة الشراء",
      Contenu1: "كود الشراء",
      Contenu2: "خلص برمز طلب ",
      BS: "لي بعدو",
      BV: "التفعيل",
      BR: "رجوع",
      ChampOb: "خانة لازمة",
      Contenu3: "رمز هذا مزال يمشي كهو ",
      Contenu4: "دقيقة",
      Contenu5: "معلومات حول عملية ",
      Contenu6: "اسم التاجر",
      Contenu7: "موقع تاجر ",
      Contenu8: "المبلغ",
      Contenu9: "مكافأة",
      Contenu10: "رقم عملية ",
      DEXP: "تاريخ الشحن",
      PNV: "خلص بكارت جديدة",
      POSTEinfo1: "E-Dinar Smart, Digicard",
      POSTEDinfo1: "Utilisez votre carte prépayée de la Poste",
      POSTEinfo2: "Visa Electron, DinarPost",
      POSTEDinfo2: "Utilisez votre carte Visa Electron ou DinarPost de la poste",
      invFormat: "Format incorrect!",
      DES6: "تبرع==حياة! حل قلبك لجمعية عن طريق التبرع على الانترنت مع صب فلوس، إنزل على الجمعية وتبع المراحل",
      DES7: "بدون موقع للتجارة الإلكترونية ، ادفع في المتاجر الفعلية أو الافتراضية ، على الشبكات الاجتماعية ، العاملين لحسابهم الخاص ، إلخ. مع رمز التاجر ، معرف التاجر على منصة صُب فلوس ",
      dT1: "أعمل تبرع",
      dDT1: "إختار جمعية",
      dT4: "نتيجة عملية ",
      dDT4: "شوف نتيجة الشراء",
      dContenu1: "أعمل تبرع",
      dContenu2: "إختار جمعية",
      cmT1: "خلص شركائنا",
      cmDT1: "دخل كود التاجر",
      cmDT3: "أكد عملية الشراء وخلص",
      cmT4: "نتيجة عملية ",
      cmDT4: "شوف نتيجة الشراء",
      cmContenu1: "خلص شركائنا",
      cmContenu2: "دخل كود التاجر",
      rsite: "نرجع موقع تاجر ",
      pc: "خلص عن طريق كود  التاجر",
      cmd: "طلب",
      mp: "شركائنا",
    },
    fid: {
      title: "نكافؤوك على الوفاء متاعك",
      subtitle: "الطريقة الأنسب باش نشكروك! برنامج وفاء الخاص بنا",
      subtitle2: "اربح نقاط على كل عملية شراء، لمدهم واربح مكافأة",
      d1: "انتقل من حالة إلى أخرى واكسب المزيد",
      d2: "تمتع مع صب فلوس ، تتكافأ على عمليات الشراء إلي تعاملهم",
      pd: "أكثر تفاصيل على برنامج وفاء",
      sValide: "الوضع مفعل",
      sActuel: "الوضع الحالي",
      sSuivant: "الوضع التالي",
      sVerouille: "الوضع مغلق",
      fid7: "الطريقة الأنسب باش نشكروك! برنامج وفاء الخاص بنا",
      fid8: "باش تبدا الولاء متاعك ، صب فلوس تهديك على كل عملية شراء نقاط وفاء، إلي تخليك تقدم فالحالة متاعك واكاك المزايا والمكافات تتزادلك مع كل تحول",
      sysProg: "نظام التقدم",
      prog1:
        "قترحو 5 حالات متاع وفاء، Standard, Silver, Gold, Diamant et VIP, لوطا القواعد باش تتعدى من حالة لأخرى",
      prog2: "باش تحل حالة ، يكفي انك تلمد عدد النقاط في فترة زمنية محددة",
      nbPoints: "عدد النقاط إلي جمعتهم",
      intervalleDate: "بعد ما تشري، تنجم دزيد فالنقاط فيسع كي تبع  المقياس هذا",
      sysCollecte: "نظام جمع النقاط",
      coll1: "بعد ما تشري، تنجم دزيد فالنقاط فيسع كي تبع  المقياس هذا",
      valUni: "قيمة الواحد بالدينار التونسي",
      ptsaG: "النقاط إلي باش تربحهم",
      sysRec: "نظام المكافأة",
      sysRec1: "طرق مختلفة باش نكافؤوك على وفائك، طرق مختلفة باش نشكروك",
      sysRecul: "نظام التراجع",
    },
    mdp: {
      cr: "بطاقة شحن",
      sc: "إختار بطاقة",
      mdp: "كيفاه نخلص ",
      cp: "تأكيد الدفع",
      cap: "أكد عملية الشراء وخلص",
      ro: "نتيجة عملية ",
      vro: "شوف نتيجة الشراء",
      op: "عملية",
      tvcb: "نحول لحساب بنكي ",
      Conf: "تأكيد",
      r: "النتيجة",
      ra: "نتيجة الشراء",
    },
    recu: {
      srv: "خدمة",
      scr: "شحن الهاتف ببطاقة شحن",
      ds: "تفاصيل خدمة ",
      op: "مشغل",
      md: "الفلوس المطلوبة",
      com: "عمولة",
      bonus: "مكافأة",
      pf: "نقاط الولاء",
      tap: "المبلغ لي لازم تخلصوا",
      rem: "تخفيض",
      nm: "اسم التاجر",
      sm: "موقع تاجر ",
      p: "نقاط",
      map: "المبلغ المطلوب",
      ns: "رقم التسلسل",
      dt: "تفاصيل العملية",
      tsw: "حول رصيدك لسطوش صب فلوس",
      mexp: "إيمايل لبعثلك",
      mrec: "إيمايل المستلم",
      dp: "تاريخ الدفع",
      numCpt: "نومرو الكونت",
      portC: "مولا الكونت",
      fraisInt: "الرسوم الدولية",
      nomP: "اسم الشريك",
      codeP: "كود الدفع",
      numCarte: "نومرو الكارط",
      refPaie: "إشارة دفع",
      idwBene: "نومرو السطوش ",
      numR: "النومرو المشرجي",
    },
    faq: {
      title: "احنا لنا بش نعاونوك ",
      subtitle: "إختر  فئة بش تنجم تلقى إجابة أسرع وأسهل ",
      search: "بحث",
      aucres: "مافمة حتى نتيجة ",
      title2: "عندك اسئلة أخرى ؟",
      subtitle2: "متتردش بش تحكي معنا كان عندك اسئلة ، احنا نكونو فرحانين  بش نعاونوك أكثر ",
      box1: "توصل مع فريق دعم ",
      box2: "تليفون ",
      box3: "بريد إلكتروني ",
      box4: "عنوان",
      box5: "لوقت",
      resoc: "شبكاتنا إجتماعية ",
      j1: "الأثنين - الجمعة ",
      j2: "سبت",
    },
    conso: {
      title: "الاستهلاك",
      display: "عرض",
      cw: "نشرجي سطوشي",
      ea: "توسيع الكل",
      ca: "غلق الكل",
      caw: "نخرج فلوسي من السطوش",
      ssf: "خدمات صب فلوس",
      pdc: "مفما حتى إستهلاك فالتاريخ  هذا",
      totalRc: "مجموع شحن سطوش صب فلوس",
      totalTr: "مجموع تحويل فلوس من سطوش صب فلوس",
      totalSer: "مجموع الخدمات إلي شريتهم من متجر SPW",
      dont: "منها",
    },
    DocCarteRech: {
      cr1: "صب كارت في تليفونك ",
      cr2: "إستفاد من خدماتك اليومية بكل سهولة باش تربح معانا نقاط وفاء وبونيس ",
      cr3: "تبع المراحل هاذي بش تشري كارتا",
      cr4: "إختار المشغل وسوم الكارتا ",
      cr5: "إختار كيفاش تحب تخلص ",
      cr6: "بعد ما تخلص بش تلقى الكود متع الكارتا إلي شريتها.",
      cr7: "إنزل على 'كود كارتا' وإستعمل الكود إلي شريتو باش تشرجي تليفونك ",
      cr8: "كيفاش تشرجي تليفونك بكارتا",
      cr9: "أريدو : *101*كود الكارتا#",
      cr10: "اورونج : *100*كود الكارتا#",
      cr11: "إتصالات تونس  : *123*كود الكارتا#",
      infoService: "معلومات على الخدمات",
      fiscal: "تمثل زيادة سعر بطاقة إعادة الشحن رسوم الطابع الضريبي التي يفرضها القانون التونسي",
      crPerdu: "كان ضيعت كود الكارتا متاع تليفون تنجم تلقاه في خانة المعاملات",
    },
    DocRechTel: {
      td1: "شرجي تليفونك بطريقة مباشرة",
      td2: "إستفاد من خدماتك اليومية بكل سهولة باش تربح معانا نقاط وفاء وبونيس",
      td3: "تبع المراحل هاذم باش تشرجي تليفونك  ",
      td4: "إكتب نومرو تليفونك والمبلغ",
      td5: "إختر كيفاش تحب تشرجي تليفونك",
      td6: "كي تشرجي تليفونك ، الفلوس يصلوا بالوقت",
      td7: "",
      td8: "باش يوصلك س.م.س من المشغل متاعك يأكدلك إلي العملية تعدات بنجاح",
    },
    DocEspece: {
      cashInEspHeader: "شرجي الحساب متاعك صب فلوس عن طريق تحويل في واحد من حساباتنا في البنك ",
      cashInEsp1: "تنجم تقوم بعمليات شراء من غير ما تستعمل كارتا متع بنك ولا متع بوسطة",
      cashInEsp2: "تبع المراحل هاذم بش تشرجي الحساب متاعك عن طريق تحويل بنكي",
      cashInEsp3: "موعدنا في واحد من الفروع البنكية ولا واحد من فروع البريد التونسي",
      cashInEsp4: "صب الفلوس إلي تحب تشرجي بهم الحساب متاعك في حساب شركة HAMTEL",
      cashInEsp5: "بعد التحويل باش تلقى رقم التحويل على الوصل",
      cashInEsp6: "تمشي لخانة شحن الولات وتعمر الطلب متاعك",
      cashInEsp7:
        "بعد ما يتم قبول الطلب متاعك من طرف المكلف بالخدمات، الفلوس يتصبولك في الحساب متاعك",
    },
    DocWallet: {
      interw1:
        "تنجم تبعث (ولا تقبل) فلوس من عند (ولا الى) حساب شخص قريبلك والفلوس توصل بالوقت، بكل أمان وبلاش فلوس. إلي باش تبعثلو فلوس لازم يكون عندو حساب صب فلوس",
      interw2: "تبع المراحل هاذي باش تبعث فلوس لحساب شخص أخر على صب فلوس",
      interw3: "إكتب نومرو الحساب ولا البريد الإلكتروني متع الشخص إلي باش تبعثلو فلوس والمبلغ",
      interw4: "خلي ميساج للشخص إلي باش تبعثلو، كان تحب",
      interw5: "أكد العملية وحساب الي باش تبعثلو فلوس يصلولو بالوقت",
      interw6: "",
    },
    en: {
      title: "إنجليزية",
    },
    fr: {
      title: "فرنسية",
    },
    ar: {
      title: "العربية",
    },
    da: {
      title: "الدارجة",
    },
    trans: {
      title: "معاملاتي",
      search: "لوج على العمليات",
      idt: "معرف العملية",
      det: "تفاصيل",
      auctran: "مفما حتى عملية موجودة",
    },
    supp: {
      title: "تحب تسكر الشكاية هاذي",
      txt: "إذا كان تأكد العملية هاذي، الشكاية تتسكر نهائياً",
      btn1: "إي نسكرها",
      btn2: "لا منسكرهاش",
      nt: "تذكرة جديد",
      t: "تذاكر",
      tn: "تذكرة نومرو",
      not: "مفماش حتى تذكرة",
      mr: "شكاياتي",
      vm: "رسالة متاعك",
      af: "زيد ملف",
      fr: "سكر الشكاية",
    },
    marchext: {
      title: "دخل معلوماتك بش تكمل تخلص",
      it: "معلومات العملية",
      dt: "تاريخ العملية",
      bsf: "مكافأة صب فلوس",
      adv: "تحب تعرف شنية المزايا كيف تخلص عن طريق صب فلوس؟",
      paysf: "علاه تخلص عن طريق كومبت صب فلوس ؟",
      db: "مكافآت",
      sr: "نظام التعويض",
      sd: "دعم مخصص",
      mvf: "نشكروكم على وفائكم",
      vcc: "كود الشراء متاعك",
      att: "ردبالك الكود صالح فقط ل-",
      prg: "تنجم  تستعمل كود الشراء باش تكمل تخلص أو تعطي  الكود لواحد من أقاربك باش يخلص في بلاصتك",
      pexp: "الدفع السريع",
      sp: "عملية الخلاص تعدات بنجاح",
      inscsf: "قيد معانا على صب فلوس",
      cn: "الدخول",
      p1: "عملية الخلاص تعدات بنجاح عند التاجر",
      rec: "تلقى لوطا وصل الدفع متاعك",
      fq: "	سهلوا حياتكم اليومية مع صب فلوس",
      rt: "شرجي تليفونك",
      ta: "حول فلوسك",
      dsf: "تعرف أكثر على صب فلوس",
      sc: "خدمات الحريف",
    },
    bloc: {
      title: "طلب التبرير",
      dtitle: "حسابك صب فلوس تسكر فالوقت الحالي",
      d1: "بطاقة تعريف متاعك مالقدام",
      d2: "بطاقة تعريف متاعك مالقدام",
      cimg: "اختار تصويرة",
      d3: "بطاقة التعريف أو جواز سفر مع صورة للوجه متاعك.",
      d4: "بطاقة التعريف أو جواز سفر مع صورة للوجه متاعك.",
      d5: "تقرير بنكي",
      d6: "تصويرة الكارت بنكار مالقدام",
      title2: "التحقق على طريق التليفون",
      dtitle2: "من فضلك دخل كود التحقق  لي وصلك على طريق الرسالة النصية",
      sno: "خدمة غير مسموح بها",
      dsno: "لازم تتعدى بمرحلة تفعيل الكومبت بش تستنفع بالخدمة هاذي",
      dsno2: "لازم تتعدى بمرحلة تأكيد الكومبت من صفحة البداية بش تستنفع بالخدمة هاذي.",
    },
    qt: {
      title: "تحويل فلوس لسطوش صب فلوس اخر",
      p1: "إنت باش تقوم بتحويل",
      p2: "من سطوشك لسطوش واحد آخر",
      id: "معرف",
      p3: "كيف تعمل تأكيد، المبلغ يتنحالك من سطوشك صب فلوس",
      vt: "أكد التحويل",
      p4: "التحويل متاع",
      p5: "تعدى بنجاح لسطوش المستفيد",
    },
    cloture: {
      title: "سكر كومبت صب فلوس وفسخ بياناتك",
      p1: "إذا كان تستحق بش نعاونوك قبل ما تسكر حسابك صب فلوس نهائياً تنجم تكلمنا عن طريق الرابط هذا",
      nc: "اتصلوا بينا",
      p2: "إذا كان حسابك تسكر معطياتك لكل بش تتفسخ ومعادش تنجم تستعمل حسابك أو تعاود تحلوا مرة أخرى لكن تنجم تعمل حساب جديد",
      rc: "علاه تحب تسكر الكومبت",
      min8: "على الأقل 8 حروف",
      cc: "سكر الكومبت",
      q: "متأكد تحب تسكر كومبت صبفلوس نهائياً؟",
    },
    gcb: {
      nocarte: "مفما حتى كارت مسجلة",
      title: "تنجم تسجل الكارت في عملية الدفع عن طريق الكارت بنكار",
      ac: "تفعيل الكارت",
      dc: "إلغاء تفعيل الكارت",
      sc: "فسخ الكارت",
    },
    popst: {
      title: "مبروك",
      title2: "وضعية وفاء جديدة",
      title3: "صب فلوس تعطيك نقاط هداية",
      title4: "نشكروك على الوفاء متاعك",
    },
    tw: {
      tw: "تحويل الفلوس إلى سطوش صب فلوس",
      tnv: "حول مرة أخرى",
      mpin: "بدل كود صب فلوس ",
      confpin: "أكد العملية عن طريق كود صب فلوس متاعك",
    },
    docBank: {
      title: "تحويل بنكي",
      d1: "مع خدمة التحويل البنكي تنجم تطلب باش تحول فلوس من منصة صب فلوس لكونط بنكار مؤكد",
      d2: "شنوا هو كونط بنكار مؤكد ؟",
      d3: "هو كونط بنكار إلي يحترم الشروط هذم",
      d4: "الكونط بنكار لازم يكون بنفس الإسم واللقب إلي مسجلين في صب فلوس وإلى الطلب متاعك باش يترفظ",
      d5: "قبل ما يصير تأكيد أول تحويل ليك، لازم تبعثلنا المعرف البنكي وإلى كشف حساب فيه رقم حسابك البنكي واضح ومقروء",
      d6: "لشكون موجهة خدمة التحويل البنكي ؟",
      d7: "المستعملين المؤكدين الكل في منصة صب فلوس.",
      d8: "زيد كونط",
      d9: "إنزل على زر +",
      d10: "عمر إستمارة الإضافة",
      d11: "نزل ملف متاع المعرف البنكي وإلى كشف حسابك البنكي",
      d12: "إنزل على تأكيد باش تبعث الطلب الإضافة متاعك",
      d13: "كيفاش تعمل تحويل للكونط بنكار ؟",
      d14: 'المسجلين إلي حساباتهم مؤكدة، ينجمو من خلال قسم "تحويل بنكي" يعملوا تحويل رصيد من كونط صب فلوس لكونط بنكار يكفي تبع المراحل هاذم :',
      d15: "إكتب مبلغ التحويل بالدينار ( أقل حاجة 20 دينار وأكثر حاجة 3000 دينار )",
      d16: "دخل رقم الحساب البنكي ( سلسلة متاع 20 رقم )",
      d17: "إختار البانكة إلي تناسب رقم الحساب البنكي.",
      d18: '"أكد التحويل كي تنزل على "تحويل"',
      d19: "معالجة الطلب متاعك ياخو أيامات",
      d20: "تنجم تعمل تحويل بنكي كان كي يبدى رصيدك صب فلوس أكبر وإلى قد المبلغ إلي بش تدفعو ( المبلغ مع العمولة )",
      d21: '"إذا كان عندك طلب تحويل بنكي مزال متعداش، متنجمش تبعث طلب تحويل بنكي واحد اخر.',
      d22: "قداش يتكلف عليا ؟",
      d23: "العمولة بالنسبة للخدمة هاذي هي 2 دينار",
      d24: "المزايا متاع تحويل بنكي على صب فلوس :",
      d25: "خرج رصيدك صب فلوس عن طريق فرع وإلى كارت بنكار",
      d26: "تمتع بتحويل مؤمن، فوري، ومتاح في أي وقت. (24/24 و 7/7 )",
    },
    docM: {
      title: "خلص تاجر",
      d1: "شنوا هو خلاص تاجر ؟",
      d2: "خدمة الدفع عن بعد هو مجموعة عمليات مبرمجة تحطت على ذمة حرفاء صب فلوس، تخليهم يخلصو مشترياتهم إلي عملوها على موقع التاجر الشريك مع صب فلوس، الدفع هذا يصر عن طريق كونط صب فلوس بطريقة مؤمنة.",
      d3: "تشغيل الخدمة",
      d4: "بعد متأكد السلة متاعك على موقع التاجر و تختار وسيلة الدفع بصب فلوس تنجم تخلص باستعمال الزوز طرق هاذم : ",
      d41: "الطريقة الاولى",
      d5: "عمر الإستمارة ودخل معلوماتك كيما الإمايل ، كلمة السر وإلى رقم تليفونك إلي رابطو بصب فلوس، بعد باش تتنقل لإستمارة تأكيد عملية الدفع وتختار وسيلة الدفع إلي تحب عليها : كارت بنكير وطنية وإلى دوولية ، كارت بريدية وإلى رصيدك صب فلوس.",
      d42: "الطريقة الثانية",
      d6: "كل عملية خلاص تاجر هي معرفة بكود خلاص وكل تاجر هو معرف بكود تاجر خاص به إلي تنجم تستعملو وقت تأكيد عملية الدفع كي تدخل لكونط صب فلوس متاعك تحت خدمة خلاص التاجر.",
      d7: "إذا كان الدفع تعدى متنجمش تعمل إلغاء للعملية.",
      d8: "الدفع لتاجر يتعدى بالوقت و التوصيل يبدى بالوقت.",
      d9: "كان ضيعت كود الدفع تنجم ترجعوا من خلال الإيستوريك متاع عمليات (الدفع لتجار)",
      d10: "كود الدفع يقعد صالح كان 60 دقيقة، بعد الوقت هذا المستعمل ماينجمش يخلص بالكود هذا ولازم يعدي كومند أخرى في موقع التاجر.",
      d43: "تنفيذ الدفع",
      d11: "المبالغ إلي باش تخلصها محطوطة بالدينار التونسي في موقع التاجر وتشمل التاكس الكل، وصالحين في أي وقت التشاور معها من قبل الحريف. السيستام  باش ياخو بعين الاعتبار الدفع بالوقت، وإذا كانو ماهوش متوفر باش نعلموك والدفع متاعك موش باش ناخذوه بعين الاعتبار. تنجم تعود تخلص في وقت اخر",
      d44: "الدفع",
      d12: "باش تعمل دفع لازم تختار صب فلوس كوسيلة دفع كي تنزل عالفلسة المحطوطة للحاجة هاذي. الدفع متاعك بخدمة صب فلوس مسير من طرف شركة هامتال إلي تقدم خدمة مؤمنة برشة. إنت تضمن لصب فلوس إلي عندك تفويضات مهمة باش تستعمل طريقة الدفع إلي خترتها وقت تأكيد الدفع. وباش تم الحاجة هذي لزمك تأكد إلي إنت صاحب كونط صب فلوس باش تخلص عن بعد و انك تتحمل العواقب الكل خلاف هذا.",
      d13: "حماية حق المستعمل",
      d14: "فترة التوصيل",
      d15: "البياع وإلى موقع التاجر لازم يبعثلك السلعة فالنهار إلي محطوط فالكومند. كان مفما حتى نهار محطوط فالكومند، توصيل السلعة وإلى إعطاء الخدمة في وقت مايفوتش شهر واحد بعد الطلب.",
      d16: "في حالة عدم إحترام وقت التوصيل ، تنجم تلغي الكومند متاعك، يكفي انك تبعث طلب من خلال كونط صب فلوس.",
      d17: "فترة التعويض",
      d18: "كان ترجع السلعة للتجار الشريك مع صب فلوس وإلى تلغي الطلب متاعك خاطر متمش إحترام فترة التوصيل وإلى خاطر السلعة إلي شريتها من موقع التاجر فيها مشكلة بعد ما وصلتك.",
      d19: "أنها غير صالحة للاستخدام المتوقع عادة من سلعة مماثلة",
      d20: "ميتماشاش مع الوصف إلي عطاه البياع ( مثال : اللون ميتمشش النوع المقدم )",
      d21: "مافيهوش النوعية إلي قال عليها البايع ( مثل : جهاز محطوط على أساس هو هادئ أما طلع صاخب )",
      d22: "لازم يصيرلك تعويض في فترة أقصاها شهر . ومع ذالك التاجر ينجم يوخر في التعويض لين يلم السلعة متاعو وإلى لين إنت تعطيه دليل على شحن السلعة.",
      d23: "التاجر لازم يرجعلك المبلغ كامل إلي حولتو ومعاهم تكاليف التوصيل.",
      d24: '"في حالة عدم إحترام وقت التوصيل ، تنجم تلغي الكومند متاعك، يكفي انك تبعث طلب من خلال كونط صب فلوس.',
      d25: "الحق فالبونيس",
      d26: "كل مستعمل عندو بونيس عاللمشتريات إلي يعملهم عند التجار الشركاء مع صب فلوس، هي نسبة تتنحى من مبلغ الشراء وتتصب في رصيد بونيس المستعمل",
      d27: "البونيس التابع للمشتري ماهوش فيكس هو متعلق بالتاجر وإلى مالخدمة على صب فلوس و يظهر قبل مايتعدى الدفع.",
      d28: "التاجر الشريك مع صب فلوس ينجم ميعطيش بونيس للمشترين لبعض  السلعة وإلى الخدمات الكل المتوفرة فالبوتيك متاعو",
      d29: "تأكيد الدفع من عند المستعمل يعني قبول السعر والبونيس التابعين لسلعة وإلى لخدمة المقدمة من عند التاجر وإلى صب فلوس.",
      d30: "مستعمل صب فلوس مينجمش يستعمل بونيس وإلى يحولو لرصيد صب فلوس كان كي يفوت صولد بونيس متاعو 5 دينارات.",
      d31: "تنجم تحول رصيد البونيس كان لرصيد صب فلوس متاعك",
      d32: "إذا كان الدفع تلغى وقتلي الحريف صارلو تعويض، مبلغ البونيس التابع للعملية إلي تلغات باش يتنحى من رصيد البونيس متاع الحريف",
      d33: "إذا كان رصيد البونيس أقل من المبلغ متاع البونيس التابع لعملية ملغاة، باش يتنحى البونيس هذا من المبلغ الكل وإلى النسبي للعملية الملغاة قبل تعويض الحريف.",
      d34: "الميزات كي تخلص تاجر بصب فلوس",
      d35: "تنجم تخلص أي تاجر (افتراضي/فعلي) شريك مع صب فلوس",
      d36: "ديمة تتمتع بمكافأة بعد كل عملية خلاص تاجر",
      d37: "خدمة بالوقت و محمية عالخر",
      d38: "تعويض بالوقت كن صارت مشكلة",
      d39: "صب فلوس تحمي المستعملين متاعها من مشاكل التحيل وإلى عدم إحترام وقت التوصيل لجميع الدفعات الكل إلي تصير بحسباتم صب فلوس",
      d40: "خدمة ساهلة في الأستعمال وتنجم تستعملها في أي وقت 24/24 7 أيام على 7 أيام",
    },
    pays: {
      Ariana: "اريانة",
      Beja: "باجة",
      BenArous: "بن عروس",
      Bizerte: "بنزرت",
      Gabes: "قابس",
      Gafsa: "قفصة",
      Jendouba: "جندوبة",
      Kairouan: "القيروان",
      Kasserine: "القصرين",
      Kebili: "قبلي",
      Kef: "الكاف",
      Mahdia: "المهدية",
      Manouba: "منوبة",
      Medenine: "مدنين",
      Monastir: "المنستير",
      Nabeul: "نابل",
      Sfax: "صفاقس",
      SidiBouzid: "سيدي بوزيد",
      Siliana: "سليانة",
      Sousse: "سوسة",
      Tataouine: "تطاوين",
      Tozeur: "توزر",
      Tunis: "تونس",
      Zaghouan: "زغوان",
      Autre: "آخر",
      tt: "المدن الكل",
      t: "الكل",
    },
    listserv: {
      title: "الخدمات الموجودة فالبوتتيك",
      t2: "",
      des: "باش تشري إنزل عل الخدمة إلي تحب عليها وتبع مراحل الشراء بطريقة الدفع صب فلوس",
    },
  },
};
